@import (reference) '../../../../../../constants/spacing.module.less';

.freight-quote-results {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  overflow: hidden;
}

.freight-quote-results-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  background: var(--light--background-color--1);
  border-bottom: solid 1px var(--default--border-color--10);
  padding: @space-16;
  height: 50px;
  min-height: 50px;
}

.header-title-row {
  align-items: center;
}

.freight-quote-results-body {
  flex: 1;
  overflow: auto;
  padding: @space-16;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.freight-quote-results-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  border-top: 1px solid var(--default--border-color--10);
  height: 50px;
  min-height: 50px;
  padding: @space-8 @space-16;
  background: var(--light--background-color--1);
}

.book-shipment-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: @space-8;
  margin-left: auto;
}

.empty-state {
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: @space-48;
  flex: 1;
}

.loading-state {
  align-items: center;
  justify-content: center;
  flex: 1;
}

.loading-spinner {
  height: 100px;
  width: 100px;
}

.sort-controls {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.sort-label {
  color: var(--default--text-color--9);
  white-space: nowrap;
}

.sort-pill {
  padding: @space-4 @space-12;
  border-radius: 16px;
  border: 1px solid var(--default--border-color--10);
  background: var(--light--background-color--1);
  color: var(--default--text-color--9);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition:
    background 0.2s,
    border-color 0.2s,
    color 0.2s;

  &:hover {
    background: var(--primary--button--hover--background-color--3);
  }
}

.sort-pill-active {
  background: var(--primary--button--selected--border-color--4);
  border-color: var(--primary--button--selected--border-color--4);
  color: var(--light--text-color--1);

  &:hover {
    background: var(--primary--button--selected--border-color--4);
  }
}

.quote-card {
  display: flex;
  gap: @space-8;
  padding: @space-12 @space-16;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  border-radius: 4px;
  text-align: start;
  background: var(--light--background-color--1);
  border: 1px solid var(--default--border-color--10);
  overflow: hidden;
}

.quote-card.is-selected {
  margin: -1px;
  background: var(--default--background-color--2);
  border: 2px solid var(--primary--button--selected--border-color--4);
}

.quote-card.is-selected:hover {
  background: var(--default--background-color--2);
}

.quote-card:hover {
  background: var(--primary--button--hover--background-color--3);
}

.carrier-and-service {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  flex: 40%;
  min-width: 0;
}

.carrier-name-row {
  display: flex;
  align-items: center;
  gap: @space-8;
  min-width: 0;
}

.carrier-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.service-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--default--text-color--9);
}

.transit-info {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  flex: 35%;
  text-align: center;
}

.delivery-date {
  color: var(--default--text-color--9);
}

.expiration-date {
  color: var(--default--text-color--9);
}

.total-charges {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 15%;
  text-align: end;
}

.guaranteed-badge {
  display: flex;
  flex-shrink: 0;
  padding: @space-0 @space-8;
  align-items: center;
  border-radius: 4px;
  background: var(--blue-11003A);
  color: var(--light--text-color--1);
  white-space: nowrap;
}

.guaranteed-badge.is-selected {
  background: var(--primary--button--selected--border-color--4);
}

.selected-quote-banner {
  display: flex;
  gap: @space-8;
  padding: @space-12 @space-16;
  justify-content: space-between;
  align-items: center;
  min-height: 72px;
  border-radius: 4px;
  text-align: start;
  background: var(--default--background-color--2);
  border: 2px solid var(--primary--button--selected--border-color--4);
}

.pickup-field {
  flex: 2;
}

.pickup-field-narrow {
  flex: 1;
}

.date-picker {
  display: flex;
  width: 100%;
}

.date-picker input {
  height: 38px;
  line-height: 38px;
  font-size: 16px;
}

.date-picker button {
  height: 38px;
}

.special-instructions {
  min-height: 80px;
}

.view-details-link {
  padding: 0;
  margin: 0;
  font-size: 12px;
  color: var(--primary--text-color--6);
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;

  &:hover {
    color: var(--primary--text-color--7);
  }
}

.details-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.details-modal {
  background: var(--light--background-color--1);
  border-radius: 8px;
  width: 480px;
  max-height: 80vh;
  overflow: auto;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.details-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: @space-16 @space-24;
  border-bottom: 1px solid var(--default--border-color--10);
}

.details-modal-body {
  padding: @space-24;
  display: flex;
  flex-flow: column nowrap;
  gap: @space-24;
}

.details-modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: @space-12 @space-24;
  border-top: 1px solid var(--default--border-color--10);
}

.details-carrier-header {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
}

.details-section {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-8;
}

.details-section-title {
  color: var(--default--text-color--9);
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.5px;
}

.details-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: @space-4 0;
}

.details-label {
  color: var(--default--text-color--9);
}

.details-value {
  font-weight: 600;
  text-align: end;
}

.details-terminal-group {
  display: flex;
  flex-flow: column nowrap;
  gap: @space-4;
}
